export default __webpack_public_path__ + "static/media/ANIMATOR_X.50fbaa05.png";